<footer class="footer">
  <div class="container">


    <!-- MENU FOOTER -->
    <div class="row footer__row footer__rowNavigation" style="margin-left:0;margin-right:0;">
      <div *ngFor="let nodo of nodoPie?.childNodes" class="col-12 col-sm-6 col-lg-3">
        <h4 class="h4">
          <a target="_blank" [href]="nodo.url">{{nodo.title}}</a>
        </h4>
        <ul class="footer__navigationItems">
          <li *ngFor="let hijo of nodo.childNodes">
            <a target="_blank" [href]="hijo.url">{{hijo.title}}</a>
          </li>
        </ul>
      </div>


      <div class="col-12 col-sm-6 col-lg-3" itemscope="itemscope" itemtype="http://schema.org/Organization">
        <h4 class="h4">
          Social
        </h4>
        <ul class="footer__navigationIcons" style="padding: 0">
          <li>
            <a href="https://www.linkedin.com/company/dhl-parcel/" target="_blank" class="disclaimer external" rel="noreferrer">
              <div class="circleIcon circleIcon--highlight">
                <span class="icon">
                  <svg role="image" title="linkedin" class="linkedin">
                    <use [attr.xlink:href]="directoryImages + '/assets/images/sprite.svg#linkedin'"></use>
                  </svg>
                </span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- IDIOMA -->
    <div class="row footer__row footer__rowLanguage">

      <div class="col-12">
        <div class="footerLanguages">
          <a lang="en" [routerLink]="rutaIngles | async">
            <img src="{{directoryImages}}/assets/images/gb.png" alt="English" />{{'Foot.EnglishMenu' | translate}}
          </a>
          <a lang="es" [routerLink]="rutaCastellano | async">
            <img src="{{directoryImages}}/assets/images/esp.png" alt="Español" />{{'Foot.SpanishMenu' | translate}}
          </a>
          <a lang="pt" [routerLink]="rutaPortugues | async">
            <img src="{{directoryImages}}/assets/images/ptg.png" alt="Portugues" />Português
          </a>
        </div>
      </div>
    </div>
    <!-- ENLACES LEGALES -->
    <div class="row footer__row footer__rowLegal">
      <div class="col-12">
        <h4 class="h4">
          <img src="{{directoryImages}}/assets/images/dhl-group.png" alt="Deutsche Post DHL Group" />
        </h4>
        <ul class="footer__navigationLegal">
          <li>
            <a target="_blank" [href]="'Foot.UrlFootPrivacity' | translate">
              {{'Foot.FootPoliticsPrivacy' | translate}}
            </a>
          </li>
          <li>
            <a target="_blank" [href]="'Foot.UrlFootNoticeLegal' | translate">
              {{'Foot.FootNoticeLegal' | translate}}
            </a>
          </li>
          <li>
            <a target="_blank" [href]="'Foot.UrlFootTerms' | translate">
              {{'Foot.FootTerms' | translate}}
            </a>
          </li>
        </ul>
        <p class="footer__copyright"><span id="anno">{{year}}</span> © DHL International GmbH. All rights reserved.</p>
      </div>
    </div>
  </div>
  <span class="btnSentStatus">
    <button id="ot-sdk-btn" type="button" class="ot-sdk-show-settings btn">Preferencia de cookies</button>
  </span>
</footer>
